import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { HttpsRequestInterceptor } from './https-request.interceptor';
import { ToastrInterceptor } from './toastr.interceptor';
import { AccessSessionInterceptor } from './access-session.interceptor';
import { OAuthService } from 'angular-oauth2-oidc';
import { LocalstorageService } from '@services/localstorage.service';
import { CacheService } from '@services/cache.service';
import { NotifyService } from '@services/notify.service';
import { AuthService } from '../auth/auth.service';
import { SessionService } from '@services/session.service';

// Interceptor execution order for REQUESTS (top → bottom):
//   1. HttpsRequestInterceptor  — attaches auth headers, handles cache
//   2. ToastrInterceptor        — shows API error notifications
//   3. AccessSessionInterceptor — validates session, handles 401, gates expired requests
//
// For RESPONSES the order is reversed (AccessSession sees the response first),
// which is why AccessSession is the authoritative 401 handler.

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpsRequestInterceptor,
      multi: true,
      deps: [LocalstorageService, CacheService, SessionService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ToastrInterceptor,
      multi: true,
      deps: [NotifyService, SessionService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccessSessionInterceptor,
      multi: true,
      deps: [LocalstorageService, NotifyService, AuthService, SessionService, OAuthService],
    },
  ],
})
export class Interceptor {}